import 'react-phone-number-input/style.css'
import { Button, Col, Flex, Form, Input, Modal, Radio, Row, Select, Switch } from "antd";
import PhoneInput from 'react-phone-number-input';
import { useForm } from "antd/es/form/Form";
import TextArea from "antd/es/input/TextArea";
import { Option } from "antd/es/mentions";
import { FC, forwardRef, useContext, useImperativeHandle, useRef, useState } from "react";
import { ResponsiveContext } from '../../context/responsive-context';
import { BookFormProps } from './Book';
import { TransparentButton } from '../../common-components/CustomButtons';

  const MyInput = forwardRef((props, ref) => {
  const inputRef = useRef(null);


  useImperativeHandle(
    ref,
    () => {
      if (inputRef.current !== null) {
        const current = inputRef.current as any
      return  current.input;
      }
      else {
        return
      }
    },
    []
  );
  return <Input {...props} ref={inputRef} />;
});

const PhoneField = ({ value, onChange, ...props }: any) => {
  return (
    <PhoneInput
      value={value}
      onChange={onChange}
      placeholder="Enter phone number"
      className="ant-input"
      defaultCountry="HU"
      international={true}
      limitMaxLength={true}
      inputComponent={MyInput}
      {...props}
    />
  );
};

export const BookForm: FC<BookFormProps> = ({ selectedForm }) => {
  const responsiveContext = useContext(ResponsiveContext)
  const [ form ] = useForm()
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isMailSent, setIsMailSent] = useState(false);
  const [clientEmail, setClientEmail] = useState('');

  const MessageConfirmation = () => {
    return (
        <Modal
          title=<div className="Book-message-sending-title">Üzenet küldése</div>
          open={isModalOpen}
          onCancel={handleCancel}
          footer={null}
          width={700}
        >
        <Flex vertical gap={'middle'} className="Book-message-sending-body" >{
          !isMailSent ?
            'Üzenet küldése folyamatban. Kérlek várj!' :
            `Üzenet elküldve! Erről kaptál egy másolatot a ${clientEmail} címre.`}
        <div className="Book-message-sending-button">
        <TransparentButton onClick={handleCancel} >OK</TransparentButton>
        </div>
        </Flex>
        </Modal>
    )
  }

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const buttonWidth = responsiveContext.useVertical ? 159 : 175


  type FormData = {
    name: string
    email: string
    telephone: string
    address?: string
    billingAddress?: string
    company?: string
    places?: string[]
    date?: string[]
    service: string
    giftcard?: boolean
    giftedName?: string
    message?: string
  }
  const handleSubmit = async (props: FormData) => {
    setIsMailSent(false)
    setClientEmail('')
    const translations: {[key: string]: string} = {
      Kecskemet: 'Kecskemét',
      Budapest: 'Budapest',
      weekend: 'Hétvége',
      weekday: 'Hétköznap',
      color: 'Színtanácsadás',
      'color-2': 'Páros színtanácsadás',
      body: 'Testalkat tanácsadás',
      'body-2': 'Páros testalkat tanácsadás',
      'color-group': 'Csoportos színtanácsadás',
      'body-group': 'Csoportos testalkat tanácsadás',
      'full': 'Teljes, szín- és testalkat tanácsadás',
      'other': 'Egyéb',
      'book': 'Foglalás',
      'company': 'Cégeknek',
      'giftcard': 'Ajándékkártya',
    }
    const url = 'https://script.google.com/macros/s/AKfycbwlBfuWciGh2JeG0qJ6DdeCKT2nHXGtK4lC-9T4Y_yWIZJjW82EE3bssk1Hr5cbMzb4/exec'
    const data = {
      formDataNameOrder: [
        'category',
        'name',
        'email',
        'telephone',
        'address',
        'billingAddress',
        'company',
        'places',
        'date',
        'service',
        'giftcard',
        'giftedName',
        'message',
      ],
      category: translations[selectedForm],
      name: props.name,
      email: props.email,
      telephone: props.telephone,
      address: props.address,
      billingAddress: props.billingAddress,
      company: props.company,
      places: props.places?.map(p => translations[p]).join(", "),
      date: props.date?.map(d => translations[d]).join(", "),
      service: translations[props.service],
      giftcard: props.giftcard !== undefined && props.giftcard ? 'van' : 'nincs',
      giftedName: props.giftedName,
      message: props.message,
      translations: {
        category: 'Kategória',
        name: 'Név',
        email: 'E-mail',
        telephone: 'Telefon',
        address: 'Cím',
        billingAddress: 'Számlázási cím',
        company: 'Cégnév',
        places: 'Helyszín',
        date: 'Időpont',
        service: 'Szolgáltatás',
        giftcard: 'Ajándékkártya',
        giftedName: 'Megajándékozott neve',
        message: 'Üzenet',
      }
    }

    showModal()


    const res = await fetch(url, {
      method: 'POST',
      body: JSON.stringify(data)
    })

    setClientEmail(props.email)
    setIsMailSent(true)
    form.resetFields()
  }


const ServiceSelector =
  <Form.Item
    name="service"
    label={<label className="Label">SZOLGÁLTATÁS</label>}
    rules={[{ required: true, message: 'Kérlek, válassz ki egy szolgáltatást!' }]}
  >
    <Radio.Group
      buttonStyle="outline"
    >
    <Row gutter={[8, 8]}>
    { (selectedForm !== 'company') &&
      <>
    <Col span={12}>
      <Radio.Button
        value="color"
        style={{ alignContent: 'center', width: buttonWidth, height: 60}}
      >
        Egyéni színtanácsadás
      </Radio.Button>
    </Col>
    <Col span={12}>
      <Radio.Button
        value="body"
        style={{ alignContent: 'center', width: buttonWidth, height: 60 }}
      >
      Egyéni testalkat tanácsadás
      </Radio.Button>
    </Col>
    <Col span={12}>
      <Radio.Button
        value="color-2"
        style={{ alignContent: 'center', width: buttonWidth, height: 60 }}
      >
        Páros színtanácsadás
      </Radio.Button>
    </Col>
    <Col span={12}>
      <Radio.Button
      value="body-2"
        style={{ alignContent: 'center', width: buttonWidth, height: 60 }}
      >
      Páros testalkat tanácsadás
      </Radio.Button>
    </Col>
    </>
    }
    <Col span={12}>
      <Radio.Button
        value="color-group"
        style={{ alignContent: 'center', width: buttonWidth, height: 60 }}
      >
        Csoportos színtanácsadás
      </Radio.Button>
    </Col>
    <Col span={12}>
      <Radio.Button
      value="body-group"
        style={{ alignContent: 'center', width: buttonWidth, height: 60 }}
      >
      Csoportos testalkat tanácsadás
      </Radio.Button>
    </Col>
    <Col span={12}>
      <Radio.Button
      value="full"
        style={{ alignContent: 'center', width: buttonWidth, height: 60 }}
      >
      Teljes tanácsadás
      </Radio.Button>
    </Col>
    <Col span={12}>
      <Radio.Button
      value="other"
        style={{ alignContent: 'center', width: buttonWidth, height: 60 }}
      >
      Egyéb (írd meg üzenetben)
      </Radio.Button>
    </Col>
    </Row>
    </Radio.Group>
  </Form.Item>


const FormGiftCard =
  <>
      <Form
        form={form}
        onFinish={handleSubmit}
        layout={'horizontal'}
        labelCol={{ span: 3 }}
        wrapperCol={{ span: 10 }}
        labelWrap
      >
        <Form.Item
          name="name"
          label={<label className="Label">NÉV</label>}
          rules={[{ required: true, type: 'string' }]}
        >
          <Input placeholder="Szabó Anna"/>
        </Form.Item>
        <Form.Item
          name="email"
          label={<label className="Label">EMAIL</label>}
          rules={[{ required: true, type: 'email' }]}
        >
          <Input placeholder="szaboanna@gmail.com"/>
        </Form.Item>
        <Form.Item
          name="address"
          label={<label className="Label">POSTACÍM</label>}
          rules={[{ required: true, type: 'string' }]}
        >
          <Input placeholder="6000 Kecskemét, Petőfi Sándor u. 1."/>
        </Form.Item>
        <Form.Item
          name="billingAddress"
          label={<label className="Label">SZÁMLÁZÁSI CÍM</label>}
          rules={[{ required: true, type: 'string' }]}
        >
          <Input placeholder="6000 Kecskemét, Petőfi Sándor u. 1."/>
        </Form.Item>
        <Form.Item
          name="telephone"
          label={<label className="Label">TEL</label>}
          rules={[{ required: true }]}
        >
        <PhoneField />
        </Form.Item>
        <Form.Item
          name="giftedName"
          label={<label className="Label">MEGAJÁNDÉKOZOTT NEVE</label>}
          rules={[{ required: true, type: 'string' }]}
        >
          <Input placeholder="Szabó Ilona"/>
        </Form.Item>
        {ServiceSelector}
        <Form.Item
          name="message"
          label={<label className="Label">ÜZENET</label>}
          rules={[{ required: false, type: 'string' }]}
        >
          <TextArea
            size="large"
            style={{ height:"150px" }}
            placeholder="Írd meg a kérdéseidet a foglalással kapcsolatban!"
          />
        </Form.Item>
        <Form.Item wrapperCol={{ span: 16 }}>
          <Button type="primary" htmlType="submit">
            Küldés
          </Button>
        </Form.Item>
      </Form>
    </>

const FormCompany =
  <>
      <Form
        form={form}
        onFinish={handleSubmit}
        layout={'horizontal'}
        labelCol={{ span: 3 }}
        wrapperCol={{ span: 10 }}
        labelWrap
      >
        <Form.Item
          name="name"
          label={<label className="Label">NÉV</label>}
          rules={[{ required: true, type: 'string' }]}
        >
          <Input placeholder="Szabó Anna"/>
        </Form.Item>
        <Form.Item
          name="email"
          label={<label className="Label">EMAIL</label>}
          rules={[{ required: true, type: 'email' }]}
        >
          <Input placeholder="szaboanna@gmail.com"/>
        </Form.Item>
        <Form.Item
          name="telephone"
          label={<label className="Label">TEL</label>}
          rules={[{ required: true }]}
        >
        <PhoneField />
        </Form.Item>
        <Form.Item
          name="company"
          label={<label className="Label">CÉGNÉV</label>}
          rules={[{ type: 'string' }]}
        >
          <Input placeholder="Színelmélet Kft."/>
        </Form.Item>
        {ServiceSelector}
        <Form.Item
          name="message"
          label={<label className="Label">ÜZENET</label>}
          rules={[{ required: false, type: 'string' }]}
        >
          <TextArea
            size="large"
            style={{ height:"150px" }}
            placeholder="Írd meg a kérdéseidet a foglalással kapcsolatban!"
          />
        </Form.Item>
        <Form.Item wrapperCol={{ span: 16 }}>
          <Button type="primary" htmlType="submit">
            Küldés
          </Button>
        </Form.Item>
      </Form>
    </>
const FormBase =
  <>
      <Form
        form={form}
        onFinish={handleSubmit}
        layout={'horizontal'}
        labelCol={{ span: 3 }}
        wrapperCol={{ span: 10 }}
        labelWrap
      >
        <Form.Item
          name="name"
          label={<label className="Label">NÉV</label>}
          rules={[{ required: true, type: 'string' }]}
        >
          <Input placeholder="Szabó Anna"/>
        </Form.Item>
        <Form.Item
          name="email"
          label={<label className="Label">EMAIL</label>}
          rules={[{ required: true, type: 'email' }]}
        >
          <Input placeholder="szaboanna@gmail.com"/>
        </Form.Item>
        <Form.Item
          name="telephone"
          label={<label className="Label">TEL</label>}
          rules={[{ required: true }]}
        >
        <PhoneField />
        </Form.Item>
        <Form.Item
          name="places"
          label={<label className="Label">HELYSZÍN</label>}
          rules={[{ required: true, message: 'Legalább egy várost válassz ki!', type: 'array' }]}
        >
          <Select mode="multiple" placeholder="Melyik városban szeretnél foglalni?">
            <Option value="Kecskemet">Kecskemét</Option>
            <Option value="Budapest">Budapest</Option>
          </Select>
        </Form.Item>
        <Form.Item
          name="date"
          label={<label className="Label">IDŐPONT</label>}
          rules={[{ required: true, message: 'Legalább egy időpontot válassz ki!', type: 'array' }]}
        >
          <Select mode="multiple" placeholder="Milyen napokon lenne neked jó?">
            <Option value="weekday">Hétköznap</Option>
            <Option value="weekend">Hétvége</Option>
          </Select>
        </Form.Item>
        {ServiceSelector}
        <Form.Item
        name="giftcard"
          label={<label className="Label">AJÁNDÉKKÁRTYÁM VAN</label>}
        valuePropName="checked" >
          <Switch />
        </Form.Item>
        <Form.Item
          name="message"
          label={<label className="Label">ÜZENET</label>}
          rules={[{ required: false, type: 'string' }]}
        >
          <TextArea
            size="large"
            style={{ height:"150px" }}
            placeholder="Írd meg a kérdéseidet a foglalással kapcsolatban!"
          />
        </Form.Item>
        <Form.Item wrapperCol={{ span: 16 }}>
          <Button type="primary" htmlType="submit">
            Küldés
          </Button>
        </Form.Item>
      </Form>
    </>

  if (selectedForm === 'giftcard') {
    return (
      <div className="Book-form-container">
      <MessageConfirmation />
        {FormGiftCard}
      </div>
    );
  }
  if (selectedForm === 'company') {
    return (
      <div className="Book-form-container">
      <MessageConfirmation />
        {FormCompany}
      </div>
    );
  }

  return (
      <div className="Book-form-container">
      <MessageConfirmation />
        {FormBase}
      </div>
  )
}

